<template>
    <div class="qksm">
        <div class="nogap">
            <h4>（一）2021年预算拨款情况</h4>
            <p>
                2021年部门预算总收入{{isMoney(T2.总计)}}万元，其中：年初预算{{isMoney(T2.年初预算)}}万元，年中追加{{T2.年中追加}}万元，其中
                <template v-for="(item,idx) in T2.追加" :key="idx">
                    {{item.name}}追加{{isMoney(item.value)}}万元{{idx + 1 == T2.追加.length ? '。' : '，'}}
                </template>
            </p>
        </div>
        <p>
            追加追减项目说明：
        </p>
        <div class="deptCon">
            <reason type="textarea" rows="5" classname="qksm format" name="Q1last" placeholder="1、... 2、..." v-model:value="qksm['Q1last']"></reason>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm1Last",
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },
        props: {
            T2: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
    };
</script>